// Orders migrated from the old shop carry no shipping lines. Their delivery is a surcharge with this
// sku, described by the carrier and, when the old shop charged nothing, a colon and the word for
// free ("Packeta", "Zásilkovna: Zdarma", "InPost Paczkomaty Box: Za darmo").
const LEGACY_SHIPPING_SKU = 'LEGACY-SHIPPING'
// The migration's other fees; any other surcharge on such an order is a piece it bought that had no
// product to become a line of (a gift voucher, a towel), under that product's sku or LEGACY-ITEM.
const LEGACY_FEE_SKUS = new Set([LEGACY_SHIPPING_SKU, 'LEGACY-FEE', 'cash-on-delivery-fee'])

interface LegacyOrder<Surcharge> {
  shippingLines?: readonly unknown[] | null
  surcharges?: readonly Surcharge[] | null
}

/**
 * The surcharge an order migrated from the old shop was delivered by, or undefined for any order
 * with a shipping line of its own.
 */
export function orderLegacyShipping<Surcharge extends { sku?: string | null }>(order: LegacyOrder<Surcharge>): Surcharge | undefined {
  if (order.shippingLines?.length)
    return undefined
  return order.surcharges?.find(surcharge => surcharge.sku === LEGACY_SHIPPING_SKU)
}

/**
 * The carrier of that delivery, what its description names before a colon ("Zásilkovna: Zdarma"
 * → "Zásilkovna"). `name` is the surcharge's description (see the `Surcharge` fragment).
 */
export function legacyShippingCarrier(surcharge?: { name?: string | null } | null): string | undefined {
  return surcharge?.name?.split(':')[0]?.trim() || undefined
}

/**
 * The goods an order migrated from the old shop holds as surcharges. Never any on an order with a
 * shipping line: a live surcharge's sku is an admin's choice or a variant's, so it cannot tell a
 * fee from goods.
 */
export function orderLegacyGoods<Surcharge extends { sku?: string | null }>(order: LegacyOrder<Surcharge>): Surcharge[] {
  if (order.shippingLines?.length)
    return []
  return (order.surcharges ?? []).filter(surcharge => !LEGACY_FEE_SKUS.has(surcharge.sku ?? ''))
}
